import React, {useRef} from 'react';
import withRoot from "../../../withRoot";
import Header from "../../../customer/ProductsCustomer/Header";
import Title from "../../../customer/ProductsCustomer/Title";
import {useMediaQuery} from "react-responsive";
import HeaderMobile from "../../../customer/ProductsCustomer/Mobile/HeaderMobile";
import TitleMobile from "../../../customer/ProductsCustomer/Mobile/TitleMobile";
import CheckoutCustomerCotizar from "./Checkout/CheckoutCotizar";
import Footer from "../../../customer/ProductsCustomer/Footer";

function Cotizar(props) {

    const isMobileDevice = useMediaQuery({
        query: "(max-device-width: 480px)",
    });
    const topFormRef = useRef()
    const handleScrollIntoView = () => {
        topFormRef.current.scrollIntoView({ behavior: 'smooth' })
    }

    return (
        <React.Fragment>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    width: "100%",
                    backgroundColor: "#F5F6F9",
                    height: "100%",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                    }}
                >
                    {isMobileDevice ? <HeaderMobile/> : <Header/>}
                </div>

                <div
                    ref={topFormRef}
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        marginBottom: "50px"
                    }}
                >
                    {isMobileDevice
                        ? <TitleMobile title={"SEGUROS"}
                                       subtitle={"Asegure su motovehículo completando la siguiente información:"}/>
                        : <Title title={"SEGUROS"}
                                 subtitle={"Asegure su motovehículo completando la siguiente información:"}/>}
                </div>

                <div style={{
                    width: "100%", display: "flex",
                    flexDirection: "row", justifyContent: "center"
                }}>
                    {typeof props.location.state !== 'undefined'
                        ?
                        <CheckoutCustomerCotizar
                            scrollIntoView={handleScrollIntoView}
                            continueCotizacion={true}
                            emisionValues={props.location.state.emisionValues}
                            idCotizacion={props.location.state.idCotizacion}
                            isMobile={isMobileDevice}/>
                        :
                        <CheckoutCustomerCotizar
                            scrollIntoView={handleScrollIntoView}
                            isMobile={isMobileDevice}/>
                    }
                </div>

                <div
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        marginTop: "80px",
                        marginBottom: "50px",
                        width: "100%"
                    }}
                >
                    <Footer/>
                </div>
            </div>
        </React.Fragment>
    );
}

export default withRoot(Cotizar);
